import { jsx, jsxs } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { WalletIcon } from '@dynamic-labs/wallet-book';
import { Typography } from '../../components/Typography/Typography.js';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import '../../config/LSSuffix.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import '../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/utils';
import '../../utils/constants/colors.js';
import 'ethers';
import '../../shared/consts/index.js';
import { useInternalDynamicContext } from '../../context/DynamicContext/useInternalDynamicContext.js';
import '@dynamic-labs/multi-wallet';
import { isSupportedNetwork } from '../../utils/functions/isSupportedNetwork/isSupportedNetwork.js';
import { pixelToRem } from '../../utils/functions/pixelToRem/pixelToRem.js';
import '../../components/ShadowDOM/ShadowDOM.js';
import '../../context/ThemeContext/ThemeContext.js';
import 'react-dom';
import 'react-focus-lock';
import '../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../config/ApiEndpoint.js';
import '@dynamic-labs/rpc-providers';
import '../../context/ErrorContext/ErrorContext.js';
import '../../context/AccessDeniedContext/AccessDeniedContext.js';
import '../../components/IconButton/IconButton.js';
import { IconWithSpinner, iconRatio } from '../../components/IconWithSpinner/IconWithSpinner.js';
import '../../components/Alert/Alert.js';
import '../../context/MockContext/MockContext.js';
import '../../context/CaptchaContext/CaptchaContext.js';
import '../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import '../../components/Popper/Popper/Popper.js';
import '../../components/Popper/PopperContext/PopperContext.js';
import 'formik';
import 'yup';
import '../../components/MenuList/Dropdown/Dropdown.js';
import { useUpdateUserProfileByJWTCallback } from '../../utils/hooks/useUpdateUserProfileByJWTCallback/useUpdateUserProfileByJWTCallback.js';

//   The component notifies the user about the required manual network change,
//   as the wallet does not support programmatic network change.
const NetworkNotSupportedSwitchManual = () => {
    var _a, _b;
    const { user, network, onboardingOnlyJwt, selectedWalletConnector: walletConnector, setShowAuthFlow, } = useInternalDynamicContext();
    const { updateUserProfileByJWT } = useUpdateUserProfileByJWTCallback();
    // Listen for network changes
    useEffect(() => {
        if (!walletConnector)
            return;
        const _isSupportedNetwork = isSupportedNetwork({
            network,
            walletConnector,
        });
        // User has changed network to supported network
        if (_isSupportedNetwork) {
            // The user had an incorrect network at the time of authorization. We finish the user's authorization.
            if (onboardingOnlyJwt) {
                updateUserProfileByJWT(onboardingOnlyJwt);
                setShowAuthFlow(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [network, onboardingOnlyJwt, walletConnector, updateUserProfileByJWT]);
    const iconSize = 80;
    const icon = (jsx(WalletIcon, { walletName: walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.name, style: {
            height: pixelToRem(iconSize * iconRatio),
            width: pixelToRem(iconSize * iconRatio),
        } }));
    return (jsxs("div", Object.assign({ className: 'network-not-supported-switch-manual' }, { children: [jsx("div", Object.assign({ className: 'network-not-supported-switch-manual__img-container' }, { children: ((_a = user === null || user === void 0 ? void 0 : user.ens) === null || _a === void 0 ? void 0 : _a.avatar) ? (jsx("div", Object.assign({ className: 'network-not-supported-switch-manual__network-container' }, { children: jsx("img", { src: (_b = user === null || user === void 0 ? void 0 : user.ens) === null || _b === void 0 ? void 0 : _b.avatar, alt: 'user ens avatar', className: 'network-not-supported-switch-manual__img' }) }))) : (jsx("div", Object.assign({ className: 'network-not-supported-switch-manual__network-container' }, { children: jsx(IconWithSpinner, { Icon: icon, iconSize: iconSize, isSpinning: true }) }))) })), jsxs("div", Object.assign({ className: 'network-not-supported-switch-manual__content' }, { children: [jsx(Typography, Object.assign({ className: 'network-not-supported-switch-manual__title', weight: 'medium', variant: 'title', color: 'primary' }, { children: "Switch Networks" })), jsx(Typography, Object.assign({ variant: 'body_normal', color: 'secondary' }, { children: "Your wallet does not support switching networks from this app. Switch networks directly in your wallet." }))] }))] })));
};

export { NetworkNotSupportedSwitchManual };
